import { paths } from 'src/routes/paths';
import axios, { endpoints } from 'src/utils/axios';
import handleOKRequest from 'src/components/grids/generic-grid/handleOKRequest';
import handleBadRequest from 'src/components/grids/generic-grid/handleBadRequest';
import { createAsyncThunk } from '@reduxjs/toolkit';

export const aprobarCotizacion = createAsyncThunk(
  'cotizacionForm/aprobarCotizacion',
  async (
    { data, navigate }: { data: any; navigate: any },
    { rejectWithValue }
  ) => {
    try {
      const response = await axios.post(
        endpoints.actions.aprobarCotizacion,
        data
      );
      handleOKRequest(response, 'Cotización aprobada correctamente.');
      navigate(paths.dashboard.produccion.orden);
      return response.data;
    } catch (error) {
      handleBadRequest(error);
      return rejectWithValue(error.response?.data || 'Error al aprobar');
    }
  }
);
